import _ from "lodash";
import { createContext, ReactElement, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { SmallTalkNotification } from "../components/smallTalkNotification";
import { initiateSmallTalkClient, triggerMessageRecevied } from "src/legacy/redux/actions/smallTalk";

export interface AppContextState {
  smallTalk: {
    client: any,
  };
}

export const AppContext = createContext<AppContextState>({
  smallTalk: {
    client: null,
  },
});

const AppContextProvider = ({ children }) => {
  const dispatch = useDispatch();

  // redux store data
  const engageEnabled = useSelector((state: any) => {
    return _.get(state, 'accounts.item.engageEnabled', false);
  });
  
  const user = useSelector((state: any) => {
    return _.get(state, 'users.me', null);
  });

  const authKey = useSelector((state: any) => {
    return _.get(state, 'legacyRootReducer.smallTalk.authKey', '');
  });

  const uuid = useSelector((state: any) => {
    return _.get(state, 'legacyRootReducer.smallTalk.uuid', '')
  });

  const session = useSelector((state: any) => {
    return _.get(state, 'legacyRootReducer.smallTalk.session', '');
  });
  const sessionRef = useRef(session);

  useEffect(() => {
    sessionRef.current = session;
  }, [session]);

  const chatUsers = useSelector((state: any) => {
    return _.get(state, 'legacyRootReducer.chatUser.items', '');
  });

  //state
  const [smallTalk, setSmallTalk] = useState<any>({
    client: null,
  });

  const initiatePubNub = (authKey: string, uuid: string) => {
    const smallTalkConfig = {
      publishKey: process.env.REACT_APP_PUBNUB_PUBLISH_KEY,
      subscribeKey: process.env.REACT_APP_PUBNUB_SUBSCRIBE_KEY,
    };
    // @ts-ignore
    const client = new PubNub({
      ...smallTalkConfig,
      authKey: authKey,
      uuid: uuid,
      logVerbosity: false,
    });

    client.subscribe({
      channels: [`${uuid}.*`],
      uuid: uuid,
      withPresence: true,
    });

    client.addListener({
      message: (event: any) => {
        const { channel, message, timetoken } = event;

        const request = {
          ...message,
          timestamp: timetoken,
        };

        var shouldNotify =
          _.includes(message.sender.associatedUsers, user?.id) ||
          (chatUsers || []).some(
            (item: any) =>
              item.id === message.sender.chatUser &&
              _.get(item, "associated", false),
          );

        if (_.get(message, 'sender.type', '') != "user" && shouldNotify) {
          if (
            sessionRef.current &&
            sessionRef.current?.channel &&
            sessionRef.current?.visible &&
            sessionRef.current?.channel[0] == channel
          ) {
            dispatch(triggerMessageRecevied(channel, message));
          } else {
            // @ts-ignore
            OneSignal.getUserId(function (userId) {
              if (userId) {
                var url = `${_.get(window, 'location.origin', '')}/engage/${_.get(message, 'sender.chatUser', '')}`;
                // @ts-ignore
                OneSignal.sendSelfNotification(
                  `${message.sender.name} has sent a new message`,
                  `${message.text}`,
                  url,
                  "https://app.paperflite.com/images/email/logo.png",
                  {
                    notificationType: "new-message",
                  },
                )
                  .then((data: any) => {
                    console.log(data);
                  })
                  .catch((error: any) => {
                    console.log(error);
                  });
              } else {
                toast(<SmallTalkNotification message={request} />, {
                  autoClose: 15000,
                });
              }
            });
          }
        } else {
          dispatch(triggerMessageRecevied(channel, request));
        }
      },
    });

    setSmallTalk({
      client,
    });
  }

  useEffect(() => {
    initiatePubNub(authKey, uuid);
  }, [authKey, uuid]);

  useEffect(() => {
    if (engageEnabled) {
      dispatch(initiateSmallTalkClient() as any);
    }
  }, [engageEnabled]);

  useEffect(() => {
    return () => {
      smallTalk.client?.unsubscribeAll();
    }
  }, []);

  return (
    <AppContext.Provider value={{
      smallTalk,
    }}>
      {children}
    </AppContext.Provider>
  )
}

export default AppContextProvider;